// Handle targeting click logic for different zones and modes
function handleTargetingClick(
  zone,
  idx,
  yourTurn,
  strategemTargetMode,
  selectedStrategemId,
  strategemTargetInfo,
  immobilizeTargetMode,
  selectedImmobilizeWeaponId,
  confuseTargetMode,
  selectedConfuseWeaponId,
  weaponTargetMode,
  selectedWeaponId,
  selectedWeaponInstanceId,
  weaponDeployTargetMode,
  weaponDeployTargetInfo,
  deployTargetMode,
  selectedDeployOrderId,
  attackMode,
  selectedAttacker,
  // Handler functions
  targetStrategem,
  targetImmobilize,
  targetConfuse,
  handleTargetDeploy,
  weaponDeployTarget,
  attachWeapon,
  attackOrder,
  // Additional parameters for imported functions
  ws,
  gameId,
  setError,
  setStrategemTargetMode,
  setSelectedStrategemId,
  setStrategemTargetInfo,
  setImmobilizeTargetMode,
  setSelectedImmobilizeWeaponId,
  setConfuseTargetMode,
  setSelectedConfuseWeaponId,
  setWeaponTargetMode,
  setSelectedWeaponId,
  setWeaponDeployTargetMode,
  setWeaponDeployTargetInfo,
  // New parameters for validation
  targetingData,
  gameState,
  userId,
  selectedDeployZone,
  // Replacement mode parameters
  replaceTargetMode,
  selectedReplaceUnitId,
  replaceTargetZone,
  setClickedUnitForReplace,
  // Animation config for strategem targeting
  strategemAnimationConfig
) {
  // ✅ FIX: Allow targeting clicks during opponent's turn if it's for counter strike deploy targeting
  // Counter strike units can be targeted even during opponent's turn
  const isCounterStrikeDeployTargeting = deployTargetMode && selectedDeployOrderId && !yourTurn;
  
  if (!yourTurn && !isCounterStrikeDeployTargeting && !strategemTargetMode) return;
  
  // Normalize zone for checking (remove 'opponent_' prefix)
  // This is used by multiple targeting modes below
  const normalizedZone = zone.replace('opponent_', '');
  
  // ✅ Check replacement mode FIRST (highest priority for full zones)
  if (replaceTargetMode && selectedReplaceUnitId) {
    // Extract selfId from userId (handle object case)
    let selfId;
    if (typeof userId === 'object' && userId !== null) {
      if (userId.id !== undefined) {
        selfId = String(userId.id);
      } else if (userId.userId !== undefined) {
        selfId = String(userId.userId);
      } else if (userId.user_id !== undefined) {
        selfId = String(userId.user_id);
      } else {
        const numericValue = Object.values(userId).find(val => typeof val === 'number');
        selfId = numericValue ? String(numericValue) : '1';
      }
    } else {
      selfId = String(userId);
    }
    
    // Check if clicked zone matches the target zone
    if (normalizedZone !== replaceTargetZone) {
      console.log('🔄 REPLACE MODE: Clicked zone does not match target zone', {
        clicked: normalizedZone,
        target: replaceTargetZone
      });
      return;
    }
    
    // Get the clicked unit from game state
    const clickedUnit = gameState?.state?.[selfId]?.playedOrders?.[normalizedZone]?.[idx];
    if (!clickedUnit) {
      console.log('🔄 REPLACE MODE: No unit found at clicked position');
      return;
    }
    
    // Store clicked unit info to trigger button rendering
    setClickedUnitForReplace({
      unit: clickedUnit,
      zone: normalizedZone,
      index: idx,
      instanceId: clickedUnit.instanceId
    });
    
    console.log('🔄 REPLACE MODE: Unit selected for replacement', {
      unit: clickedUnit.name,
      zone: normalizedZone,
      index: idx
    });
    
    return;
  }
  
  // ✅ FIX: Check deploy targeting FIRST before any weapon targeting
  if (deployTargetMode && selectedDeployOrderId) {
    // Extract selfId from userId (handle object case)
    let selfId;
    if (typeof userId === 'object' && userId !== null) {
      if (userId.id !== undefined) {
        selfId = String(userId.id);
      } else if (userId.userId !== undefined) {
        selfId = String(userId.userId);
      } else if (userId.user_id !== undefined) {
        selfId = String(userId.user_id);
      } else {
        const numericValue = Object.values(userId).find(val => typeof val === 'number');
        selfId = numericValue ? String(numericValue) : '1';
      }
    } else {
      selfId = String(userId);
    }
    
    const stateIds = Object.keys(gameState?.state || {});
    const opponentId = stateIds.find(id => id !== selfId);
    
    // Simple logic: if zone starts with 'opponent_', it's an enemy click
    const isFriendlyClick = !zone.startsWith('opponent_');
    const isEnemyClick = zone.startsWith('opponent_');
    
    const targetZone = isEnemyClick ? zone : zone; // Use zone as-is for both cases
    const targetPlayer = isEnemyClick ? "opponent" : "friendly";
    
    handleTargetDeploy(targetZone, idx, targetPlayer);
    return;
  }
  
  // Strategem targeting mode
  if (strategemTargetMode && selectedStrategemId) {
    // Check if this is zone targeting or unit targeting based on strategem type
    // Use strategemTargetInfo.type OR check targetingOptions for zone targeting
    const targetingOptions = strategemTargetInfo?.targetingOptions?.[0];
    const isZoneTargeting = strategemTargetInfo?.type === 'zone' || targetingOptions?.targeting === 'zone';
    
    console.log('🎯 handleTargetingClick: Strategem targeting check', {
      strategemInfoType: strategemTargetInfo?.type,
      targetingOptionsType: targetingOptions?.targeting,
      isZoneTargeting
    });
    
    if (isZoneTargeting) {
      // Zone targeting - clicking anywhere in the zone (including units) should target the zone
      // Zone already includes opponent_ prefix if it's an opponent zone
      targetStrategem("zone", zone, null, null, null, ws, gameId, setError, setStrategemTargetMode, setSelectedStrategemId, setStrategemTargetInfo, strategemAnimationConfig);
      return;
    } else {
      // Unit targeting - handle specific unit targeting
      // Determine if this is a friendly or opponent unit based on zone prefix
      const isOpponentUnit = zone.startsWith('opponent_');
      const targetUnitId = isOpponentUnit ? "opponent" : "friendly";
      
      
      // Get the target unit to extract instanceId
      let selfId;
      if (typeof userId === 'object' && userId !== null) {
        if (userId.id !== undefined) {
          selfId = String(userId.id);
        } else if (userId.userId !== undefined) {
          selfId = String(userId.userId);
        } else if (userId.user_id !== undefined) {
          selfId = String(userId.user_id);
        } else {
          const numericValue = Object.values(userId).find(val => typeof val === 'number');
          selfId = numericValue ? String(numericValue) : '1';
        }
      } else {
        selfId = String(userId);
      }
      
      const stateIds = Object.keys(gameState?.state || {});
      const opponentId = stateIds.find(id => id !== selfId);
      
      let targetUnit = null;
      let targetInstanceId = null;
      
      // Normalize zone for checks (remove opponent_ prefix if present)
      const normalizedZone = zone.replace('opponent_', '');
      
      // Check friendly units first (friendly zones are "front" or "flank" without prefix)
      if (!zone.startsWith('opponent_')) {
        // This is a friendly zone click
        if (gameState?.state?.[selfId]?.playedOrders?.[normalizedZone]?.[idx]) {
          targetUnit = gameState.state[selfId].playedOrders[normalizedZone][idx];
          targetInstanceId = targetUnit?.instanceId;
        }
      }
      
      // Check enemy units (both with and without opponent_ prefix)
      if (!targetUnit) {
        // First try with the zone as-is
        if (gameState?.state?.[opponentId]?.playedOrders?.[zone]?.[idx]) {
          targetUnit = gameState.state[opponentId].playedOrders[zone][idx];
          targetInstanceId = targetUnit?.instanceId;
        }
        // Then try with normalized zone (for opponent zones with prefix)
        else if (zone.startsWith('opponent_')) {
          if (gameState?.state?.[opponentId]?.playedOrders?.[normalizedZone]?.[idx]) {
            targetUnit = gameState.state[opponentId].playedOrders[normalizedZone][idx];
            targetInstanceId = targetUnit?.instanceId;
          }
        }
      }
      
      // Backend expects targetType "unit", not "enemy_unit"
      targetStrategem("unit", zone, idx, targetUnitId, targetInstanceId, ws, gameId, setError, setStrategemTargetMode, setSelectedStrategemId, setStrategemTargetInfo, strategemAnimationConfig);
      return;
    }
  }
  
  // Immobilize targeting mode
  if (immobilizeTargetMode && selectedImmobilizeWeaponId) {
    targetImmobilize(`opponent_${zone}`, idx, ws, setError, setImmobilizeTargetMode, setSelectedImmobilizeWeaponId);
    return;
  }
  
  // Confuse targeting mode
  if (confuseTargetMode && selectedConfuseWeaponId) {
    targetConfuse(`opponent_${zone}`, idx, ws, setError, setConfuseTargetMode, setSelectedConfuseWeaponId);
    return;
  }
  
  // Weapon deploy targeting mode (for weapons with deploy effects)
  if (weaponDeployTargetMode && weaponDeployTargetInfo) {
    // Find the target unit from the game state
    // Extract selfId from userId (handle object case)
    let selfId;
    if (typeof userId === 'object' && userId !== null) {
      if (userId.id !== undefined) {
        selfId = String(userId.id);
      } else if (userId.userId !== undefined) {
        selfId = String(userId.userId);
      } else if (userId.user_id !== undefined) {
        selfId = String(userId.user_id);
      } else {
        const numericValue = Object.values(userId).find(val => typeof val === 'number');
        selfId = numericValue ? String(numericValue) : '1';
      }
    } else {
      selfId = String(userId);
    }
    const stateIds = Object.keys(gameState?.state || {});
    const opponentId = stateIds.find(id => id !== selfId);
    
    let targetUnit = null;
    
    // Check friendly units first (use original zone for friendly units)
    if (gameState?.state?.[selfId]?.playedOrders?.[zone]?.[idx]) {
      targetUnit = gameState.state[selfId].playedOrders[zone][idx];
    }
    // Check enemy units (use original zone for enemy units)
    else if (gameState?.state?.[opponentId]?.playedOrders?.[zone]?.[idx]) {
      targetUnit = gameState.state[opponentId].playedOrders[zone][idx];
    }
    // Handle opponent zones - convert opponent_front to front when looking in opponent's state
    else if (zone.startsWith('opponent_')) {
      const actualZone = zone.replace('opponent_', '');
      if (gameState?.state?.[opponentId]?.playedOrders?.[actualZone]?.[idx]) {
        targetUnit = gameState.state[opponentId].playedOrders[actualZone][idx];
      }
    }
    
    if (!targetUnit) {
      return;
    }
    
    const targetUnitWithZone = {
      ...targetUnit,
      zone: zone,
      index: idx
    };
    
    weaponDeployTarget(targetUnitWithZone, ws, setError, weaponDeployTargetInfo, gameId);
    return;
  }
  
  // Weapon targeting mode
  if (weaponTargetMode && selectedWeaponId) {
    // Find the target unit from the game state
    // Extract selfId from userId (handle object case)
    let selfId;
    if (typeof userId === 'object' && userId !== null) {
      if (userId.id !== undefined) {
        selfId = String(userId.id);
      } else if (userId.userId !== undefined) {
        selfId = String(userId.userId);
      } else if (userId.user_id !== undefined) {
        selfId = String(userId.user_id);
      } else {
        const numericValue = Object.values(userId).find(val => typeof val === 'number');
        selfId = numericValue ? String(numericValue) : '1';
      }
    } else {
      selfId = String(userId);
    }
    const stateIds = Object.keys(gameState?.state || {});
    const opponentId = stateIds.find(id => id !== selfId);
    
    // Check both friendly and enemy units for weapon targeting
    let targetUnit = null;
    let targetZone = null;
    let targetIndex = null;
    
    // Check friendly units first (use original zone for friendly units)
    if (gameState?.state?.[selfId]?.playedOrders?.[zone]?.[idx]) {
      targetUnit = gameState.state[selfId].playedOrders[zone][idx];
      targetZone = zone; // Keep original zone for frontend display
      targetIndex = idx;
    }
    // Check enemy units (use original zone for enemy units)
    else if (gameState?.state?.[opponentId]?.playedOrders?.[zone]?.[idx]) {
      targetUnit = gameState.state[opponentId].playedOrders[zone][idx];
      targetZone = zone; // Keep original zone for frontend display
      targetIndex = idx;
    }
    // Handle opponent zones - convert opponent_front to front when looking in opponent's state
    else if (zone.startsWith('opponent_')) {
      const actualZone = zone.replace('opponent_', '');
      if (gameState?.state?.[opponentId]?.playedOrders?.[actualZone]?.[idx]) {
        targetUnit = gameState.state[opponentId].playedOrders[actualZone][idx];
        targetZone = zone; // Keep original zone for display
        targetIndex = idx;
      }
    }
    
    if (targetUnit) {
      // Create unit object with zone and index information
      const unitObject = {
        ...targetUnit,
        zone: targetZone,
        index: targetIndex
      };
      
      attachWeapon(unitObject, ws, setError, setWeaponTargetMode, selectedWeaponId, setSelectedWeaponId, selectedWeaponInstanceId, gameId, userId, gameState, setWeaponDeployTargetMode, setWeaponDeployTargetInfo);
      return;
    } else {
      setError("No target unit found at that location");
      return;
    }
  }
  
  
  // Attack mode
  // When in attack mode, allow attacking any target (friend or foe)
  // The attackOrder function will validate the target is valid
  if (attackMode && selectedAttacker) {
    console.log('🎯 ===== HANDLE TARGETING CLICK: ATTACK MODE =====');
    console.log('🎯 Zone:', zone);
    console.log('🎯 Index:', idx);
    console.log('🎯 Selected attacker:', selectedAttacker);
    console.log('🎯 Your turn:', yourTurn);
    
    // ✅ OOR VALIDATION: Check if target has Out of Reach status
    // Extract selfId from userId (handle object case)
    let selfId;
    if (typeof userId === 'object' && userId !== null) {
      if (userId.id !== undefined) {
        selfId = String(userId.id);
      } else if (userId.userId !== undefined) {
        selfId = String(userId.userId);
      } else if (userId.user_id !== undefined) {
        selfId = String(userId.user_id);
      } else {
        const numericValue = Object.values(userId).find(val => typeof val === 'number');
        selfId = numericValue ? String(numericValue) : '1';
      }
    } else {
      selfId = String(userId);
    }
    const stateIds = Object.keys(gameState?.state || {});
    const opponentId = stateIds.find(id => id !== selfId);
    
    // Get the target unit
    const normalizedZone = zone.replace('opponent_', '');
    const isOpponentZone = zone.startsWith('opponent_');
    let targetUnit = null;
    
    if (isOpponentZone) {
      targetUnit = gameState?.state?.[opponentId]?.playedOrders?.[normalizedZone]?.[idx];
    } else {
      targetUnit = gameState?.state?.[selfId]?.playedOrders?.[normalizedZone]?.[idx];
    }
    
    // Get the attacker unit
    const attackerUnit = gameState?.state?.[selfId]?.playedOrders?.[selectedAttacker.zone]?.[selectedAttacker.idx];
    
    // ✅ VALIDATION: Check if attacker has 0 attack rating - cannot attack
    if (attackerUnit) {
      const attackRating = attackerUnit.attack_rating ?? 0;
      if (attackRating === 0) {
        console.log(`🎯 Attack blocked: Unit ${attackerUnit.name} has 0 attack rating and cannot attack`);
        if (setError) {
          setError('This unit has 0 attack rating and cannot attack');
        }
        return; // Block the attack
      }
    }
    
    // Check OOR status: OOR units cannot be attacked by ANYONE, regardless of Blitz
    // CRITICAL: Blitz only allows attacking the same turn you're deployed, NOT bypassing OOR
    if (targetUnit && targetUnit.isOOR) {
      console.log(`🎯 OOR Status: Cannot attack ${targetUnit.name} - has Out of Reach status (OOR units cannot be attacked by anyone)`);
      if (setError) {
        setError(`Cannot attack ${targetUnit.name} - target has Out of Reach status. OOR units cannot be attacked.`);
      }
      return; // Block the attack
    }
    
    // Pass the exact zone that was clicked (e.g., "opponent_front", "front", etc.)
    console.log('🎯 Calling attackOrder:', {
      attackerZone: selectedAttacker.zone,
      attackerIdx: selectedAttacker.idx,
      targetZone: zone,
      targetIdx: idx
    });
    attackOrder(selectedAttacker.zone, selectedAttacker.idx, zone, idx);
    return;
  } else {
    console.log('🎯 handleTargetingClick: Not in attack mode or no selected attacker', {
      attackMode,
      selectedAttacker,
      yourTurn
    });
  }
}

export default handleTargetingClick;

